// @flow

import _ from 'lodash/fp';
import React from 'react';
import FormattedDate from '../FormattedDate/FormattedDate';
import ActionConfirmation from '../../containers/ActionConfirmation/ActionConfirmation';
import {apiBase} from '../../helpers/request';
import './FileList.css';

const fileUrl = `${apiBase}/files`;

export type Props = {
  list: any[],
  label: string,
  onRemove?: Function,
  disabled?: boolean,
};

const FileList = ({
  label,
  list,
  onRemove,
  disabled = false,
}: Props) => (
  <div className="FileList">
    <label>
      {label}
    </label>
    <div className="file-list">
      {(!list || !list.length) &&
        <div className="empty-item">
          Inga {_.toLower(label)}
        </div>
      }
      {!!(list && list.length) &&
        _.map(f => (
          <div
            key={f.id}
            className="row no-row-margins expand">
            <a
              href={`${fileUrl}/${f.id}?download`}
              target="_blank"
              className="column item text-truncate">
              <FormattedDate
                className="item-date"
                value={f.archived} />
              <span className="item-name">{f.name + f.extension}</span>
            </a>
            {!!onRemove && !disabled &&
              <ActionConfirmation
                id={`removeFile-${f.id}`}
                wrapperClassName="shrink"
                className="tiny"
                message="Vill du verkligen ta bort den här filen? (går ej att ångra)"
                action={() => onRemove && onRemove(f)}>
                <i className="fa fa-trash fa-fw"></i>
              </ActionConfirmation>
            }
          </div>
        ), list)
      }
    </div>
  </div>
);

export default FileList;



// WEBPACK FOOTER //
// ./src/components/FileList/FileList.js